import React, { Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators } from 'redux'
import { withTranslation } from 'react-i18next'

import { actions as maintenanceActions } from '../../actions/maintenance'

import { history } from '../../store'
import { NavigationTo } from "./common";

const ONE_MINUTE = 60000;

export class MaintenanceCheck extends Component {

  checkMaintenance = () => {
    this.props.actions.maintenance.checkMaintenaceStatus().then(isLive => {
      if(!isLive) {
        history.push(NavigationTo.Maintenance, {});
      }
    })
  }

  componentDidMount() {
    setInterval(this.checkMaintenance, ONE_MINUTE);
  }

  render() {
    return null;
  }
}

const mapState = state => ({});

const mapDispatchToProps = dispatch => ({
  actions: {
    maintenance: bindActionCreators(maintenanceActions, dispatch)
  }
});

export default connect(mapState, mapDispatchToProps)(withTranslation('translationsV2')(MaintenanceCheck));